import { getFullUrlWithCurrentSubDomain } from 'hubspot-url-utils';
import PortalIdParser from 'PortalIdParser';
let appUrls;
const getAppUrls = () => {
  if (appUrls) return appUrls;
  const baseUrl = getFullUrlWithCurrentSubDomain();
  const portalId = PortalIdParser.get();
  appUrls = {
    accountAndBillingUrl: `${baseUrl}/account-and-billing/${portalId}/overview`,
    callAnalyticsUrl: `${baseUrl}/call-analytics/${portalId}`,
    callIndexUrl: `${baseUrl}/contacts/${portalId}/objects/0-48/views/all/list`,
    callingConfigurationSettingsUrl: `${baseUrl}/settings/${portalId}/calling/callconfigurations`,
    callingIvrSettingsUrl: `${baseUrl}/settings/${portalId}/calling/ivr`,
    callingMainSettingsUrl: `${baseUrl}/settings/${portalId}/calling/numbers`,
    callingToolSettingsUrl: `${baseUrl}/settings/${portalId}/calling`,
    callingUserPreferencesUrl: `${baseUrl}/settings/${portalId}/user-preferences/calling`,
    calendarUserPreferencesUrl: `${baseUrl}/settings/${portalId}/user-preferences/calendar`,
    contactsIndexUrl: `${baseUrl}/contacts/${portalId}/objects/0-1/views/all/list`,
    customerAgentManageUrl: `${baseUrl}/customer-agent/${portalId}`,
    // append aiAgentUserId/manage/page
    customerAgentOnboardingUrl: `${baseUrl}/customer-agent/${portalId}/onboarding`,
    helpDeskSettingsUrl: `${baseUrl}/helpdesk-settings/${portalId}/inboxes`,
    inboxSettingsUrl: `${baseUrl}/live-messages-settings/${portalId}/inboxes`,
    individualUserSettingsUrl: `${baseUrl}/settings/${portalId}/users/user/`,
    // append userId
    integrationsSettingsUrl: `${baseUrl}/connected-apps/${portalId}/installed`,
    integrationsUrl: `${baseUrl}/ecosystem/${portalId}/marketplace/apps/calling`,
    marketplace: `${baseUrl}/ecosystem/${portalId}/marketplace/apps/calling`,
    paidUsersManagementUrl: `${baseUrl}/settings/${portalId}/users`,
    recordingReviewUrl: `${baseUrl}/calls/${portalId}/review`,
    // append engagementId
    supportUrl: `${baseUrl}/support/${portalId}/open`,
    usersAndTeamsSettingsUrl: `${baseUrl}/settings/${portalId}/users`,
    accountVerificationUrl: `${baseUrl}/account-verification/${portalId}?source=CALLING`,
    playListsUrl: `${baseUrl}/playlists/${portalId}`,
    notificationPreferencesUrl: `${baseUrl}/notification-preferences/${portalId}`,
    meetingsNotetakerSettingsUrl: `${baseUrl}/settings/${portalId}/meetings/notetaker`,
    numberVerificationSettingsUrl: `${baseUrl}/settings/${portalId}/calling/number-verification`,
    smsSettingsUrl: `${baseUrl}/settings/${portalId}/messaging/sms`
  };
  return appUrls;
};
export const getAppUrl = (key, subpath) => `${getAppUrls()[key]}${subpath ? `/${subpath}` : ''}`;
export default getAppUrls;